import theme from "./theme";
import gdpr from "./gdpr";
import newsletter from "./newsletter";
import contact from "./contact";
import socialMedia from "./social-media";
import downloadPopup from "./download-popup";

const config = {
    name: 'config',
    label: 'Settings',
    i18n: {
        structure: 'single_file',
        locales: ['en', 'cn']
    },
    editor: {
        preview: false
    },
    files: [theme, contact, gdpr, newsletter, socialMedia, downloadPopup]
}

export default config
